import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';
import { Field } from 'redux-form';
import { FormCheckboxField } from '../../../../../../../../semantic-ui/components/form-checkbox-field';
import { TableComponent } from '../../../../../../../../components/table-component';
import { TABLE_SETTINGS_COLUMNS_NAMES } from '../../../../../constants';

const CompanyAdminSettingsFormView = ({ change, formValues }) => {
	const tableTransportsRows = [
		{
			id: 'transports',
			label: 'Транспорт моих ТЭО',
			value: (
				<div className="company-settings-form-view__checkbox">
					<Field
						name="transports"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						checked={formValues?.transports}
						onChange={(event, { checked }) => change('transports', checked)}
					/>
				</div>
			),
		},
		{
			id: 'my_transports',
			label: 'Мой автопарк',
			value: (
				<div className="company-settings-form-view__checkbox">
					<Field
						name="my_transports"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						checked={formValues?.my_transports}
						onChange={(event, { checked }) => change('my_transports', checked)}
					/>
				</div>
			),
		},
		{
			id: 'claims',
			label: 'Претензии',
			value: (
				<div className="company-settings-form-view__checkbox">
					<Field
						name="claims"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						checked={formValues?.claims}
						onChange={(event, { checked }) => change('claims', checked)}
					/>
				</div>
			),
		},
	];

	return (
		<div>
			<div className="company-settings-form-view__header_text_section">Настройки модулей</div>
			<TableComponent
				columns={TABLE_SETTINGS_COLUMNS_NAMES}
				rows={tableTransportsRows}
				isWithoutHeader
				isChildren
				isInfo
				isWithoutTableHeader
			/>
		</div>
	);
};

CompanyAdminSettingsFormView.propTypes = {
	companyAdminSettingInfo: PropTypes.object.isRequired,
	change: PropTypes.func.isRequired,
	formValues: PropTypes.object.isRequired,
};

export { CompanyAdminSettingsFormView };
